/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const contentDeleteBodyLineageUuidsMax = 100;

export const ContentDeleteBody = zod.object({
  idempotencyKey: zod
    .uuid()
    .describe(
      'Caller-generated, required. The same key and the same lineages replay the stored acknowledgement without deleting again; the same key with different lineages is a 409. Shared with GraphQL `deleteContent`, which is the same operation.',
    ),
  lineageUuids: zod
    .array(zod.uuid().describe('UUID v4 identifier'))
    .min(1)
    .max(contentDeleteBodyLineageUuidsMax)
    .describe(
      'Lineages to delete. Each resolves to its current head and cascades to everything it CONTAINS. All-or-nothing: one refusal rolls back the whole batch.',
    ),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
});

export type ContentDeleteBody = zod.input<typeof ContentDeleteBody>;
export type ContentDeleteBodyOutput = zod.output<typeof ContentDeleteBody>;
